import { CenteredModal, LargeModal } from 'components';
import { useApp, useSprint } from 'hooks';
import { Pencil, Plus, Trash2 } from 'lucide-react'
import React, { useCallback, useEffect, useState } from 'react'
import { formatDDMMYY } from 'utils';
import SprintForm from './SprintForm';
import { EProjectActions } from 'types';

export default function Sprint() {
    const { trans, onUpdateParams, dataSprints, projectDetail } = useApp();
    console.log("🚀 ~ Sprint ~ projectDetail:", projectDetail)
    const projectId = projectDetail?.id;
    const [isFetch, setIsFetch] = useState(1)
    const [item, setItem] = useState(null)
    const [actions, setActions] = useState('')
    const [dataTables, setDataTables] = useState([])
    const { fetchData, updateSprint, createSprint, delSprint } = useSprint();
    const [currentSprintPage] = useState(1);

    const { data } = fetchData(projectId, currentSprintPage, isFetch)

    useEffect(() => {
        if (projectId) setIsFetch(s => ++s)
    }, [projectId]);


    useEffect(() => {
        setDataTables(dataSprints ?? []);
    }, [JSON.stringify(dataSprints ?? '')]);

    useEffect(() => {
        onUpdateParams({ dataSprints: data?.data ?? [] })
    }, [JSON.stringify(data ?? '')]);

    const onClose = (isf = false) => {
        setActions('');
        setItem(null);
        isf && setIsFetch(s => ++s)
    }

    const handleSubmit = (formData) => {
        console.log("🚀 ~ handleSubmit ~ formData:", formData)
        formData = formData ? { ...formData, project_id: projectId } : {}
        switch (actions) {
            case 'edit':
                updateSprint.mutate(formData, {
                    onSuccess: () => {
                        onClose(true);
                    }
                })
                break;
            case 'add':
                createSprint.mutate(formData, {
                    onSuccess: () => {
                        onClose(true);
                    }
                })
                break;
            case 'delete':
                delSprint.mutate({ ...formData, id: item.id }, {
                    onSuccess: () => {
                        onClose(true);
                    }
                })
                break;
            default:
                break;
        }
    }

    const renderModalAddUpdate = useCallback(() => (['edit', 'add'].includes(actions)) ? (
        <LargeModal title={`${trans(actions)} phiên bản`} onClose={onClose} >
            <SprintForm onClose={onClose} onConfirm={handleSubmit} item={item} />
        </LargeModal>) : <></>, [actions, item]);

    return (
        <div >
            <div className="flex justify-end mb-2">
                {projectDetail?.status === EProjectActions.IN_PROGRESS && <button onClick={() => setActions('add')} className=" bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition-colors text-sm">
                    <div className="justify-center flex items-center">
                        <Plus className="w-4 h-4 mr-1" />
                        <span>Thêm</span>
                    </div>
                </button>}
            </div>
            <div className="overflow-x-auto bg-white shadow">
                {!!dataTables.length && <table className="min-w-full table-auto">
                    <thead className="bg-gray-100 text-gray-700 text-sm">
                        <tr>
                            <th className="p-3 text-left">Tên</th>
                            <th className="p-3 text-left">Mô tả</th>
                            <th className="p-3 text-left">Ngày bắt đầu</th>
                            <th className="p-3 text-left">Ngày đến hạn</th>
                            <th className="p-3 text-left">Trạng thái</th>
                            <th className="p-3 text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm text-gray-600">
                        {dataTables.map((sprint) => (
                            <tr key={sprint.id} className="border-t hover:bg-gray-50 border-gray-200">
                                <td className="p-3 flex items-center gap-3">
                                    {sprint?.name}
                                </td>
                                <td className="p-3">{sprint?.description}</td>
                                <td className="p-3">{formatDDMMYY(sprint?.start_date)}</td>
                                <td className="p-3">{formatDDMMYY(sprint?.end_date)}</td>
                                <td className="p-3">
                                    <span className={`px-2 py-1 text-xs font-medium ${["active", "done"].includes(sprint?.status)
                                        ? "bg-green-100 text-green-600"
                                        : "bg-red-100 text-red-500"
                                        }`}>
                                        {sprint?.status}
                                    </span>
                                </td>
                                <td className="p-3 flex justify-center gap-2 text-gray-500">
                                    <Pencil onClick={() => { setItem(sprint); setActions('edit') }} className="w-4 h-4 cursor-pointer hover:text-blue-600" />
                                    <Trash2 onClick={() => { setItem(sprint); setActions('delete') }} className="w-4 h-4 cursor-pointer hover:text-red-600" />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>}
            </div>

            {projectDetail?.status === EProjectActions.IN_PROGRESS && renderModalAddUpdate()}
            {(['delete'].includes(actions)) && <CenteredModal type={actions} title='Xoá phiên bản' description='Bạn có chắc muốn xoá phiên bản này không?' onClose={onClose} onConfirm={() => handleSubmit({})} />}
        </div>
    )
}
